import { useQuery } from '@tanstack/react-query';

import type { Shops } from '@/Swagger';
import axiosInstance from '@/axios/axios';

import { queryKeys } from '../../queryKeys';

/**
 * 메타데이터 map RQ.
 */
export default function useGetMetadataMap(query: Shops.MetadataMapList.RequestQuery) {
  return useQuery({
    queryKey: [...queryKeys.metadataMap, query],
    queryFn: async ({ queryKey }) => {
      const [key, params] = queryKey;

      return axiosInstance
        .get<Shops.MetadataMapList.ResponseBody>('/shops/metadata-map', { params })
        .then(v => v.data.descriptions ?? {});
    },
    staleTime: 1000 * 60 * 60 * 24,
    gcTime: 1000 * 60 * 60 * 24,
    refetchOnWindowFocus: false,
  });
}
